
import { useState, FormEvent } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    furigana: '',
    company: '',
    email: '',
    phone: '',
    message: '',
    agree: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!formData.agree) {
      alert('プライバシーポリシーに同意してください。');
      return;
    }

    if (formData.message.length > 500) {
      alert('お問い合わせ内容は500文字以内で入力してください。');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams({
        name: formData.name,
        furigana: formData.furigana,
        company: formData.company,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      }).toString();

      const response = await fetch('https://readdy.ai/api/form/d4p2fpqr20r5k3vfkepg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody,
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          furigana: '',
          company: '',
          email: '',
          phone: '',
          message: '',
          agree: false,
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('送信エラー:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-36 bg-gradient-to-br from-[#F0F8FF] via-[#FFFFFF] to-[#F0F8FF]">
      <div className="max-w-[900px] mx-auto px-10">
        {/* セクションタイトル */}
        <div className="text-center mb-14">
          <p className="text-xs font-semibold tracking-widest bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-4">
            CONTACT
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B3C] mb-8">
            お問い合わせ・ご相談
          </h2>
          <p className="text-lg leading-relaxed text-[#3A4A5A] max-w-[700px] mx-auto">
            講座・研修のご依頼、法人・自治体との連携、<br />
            ボディスキャンや光美容、ペット関連プログラムに関するご相談など、<br />
            お気軽にお問い合わせください。
          </p>
        </div>

        {/* フォーム */}
        <div className="bg-white rounded-[24px] p-14 shadow-xl">
          <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-8">
            {/* お名前 */}
            <div>
              <label htmlFor="name" className="block text-sm font-semibold text-[#1A2B3C] mb-3">
                お名前 <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full bg-[#F7F9FB] border border-transparent rounded-xl px-5 py-4 text-[15px] text-[#1A2B3C] focus:outline-none focus:border-[#4A90E2] focus:ring-2 focus:ring-[#4A90E2]/20 transition-all duration-300"
                placeholder="山田 太郎"
              />
            </div>

            {/* ふりがな */}
            <div>
              <label htmlFor="furigana" className="block text-sm font-semibold text-[#1A2B3C] mb-3">
                ふりがな <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="furigana"
                name="furigana"
                value={formData.furigana}
                onChange={handleChange}
                required
                className="w-full bg-[#F7F9FB] border border-transparent rounded-xl px-5 py-4 text-[15px] text-[#1A2B3C] focus:outline-none focus:border-[#4A90E2] focus:ring-2 focus:ring-[#4A90E2]/20 transition-all duration-300"
                placeholder="やまだ たろう"
              />
            </div>

            {/* 企業・団体名 */}
            <div>
              <label htmlFor="company" className="block text-sm font-semibold text-[#1A2B3C] mb-3">
                企業・団体名
              </label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full bg-[#F7F9FB] border border-transparent rounded-xl px-5 py-4 text-[15px] text-[#1A2B3C] focus:outline-none focus:border-[#4A90E2] focus:ring-2 focus:ring-[#4A90E2]/20 transition-all duration-300"
                placeholder="株式会社〇〇"
              />
            </div>

            {/* メールアドレス */}
            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-[#1A2B3C] mb-3">
                メールアドレス <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full bg-[#F7F9FB] border border-transparent rounded-xl px-5 py-4 text-[15px] text-[#1A2B3C] focus:outline-none focus:border-[#4A90E2] focus:ring-2 focus:ring-[#4A90E2]/20 transition-all duration-300"
                placeholder="example@email.com"
              />
            </div>

            {/* 電話番号 */}
            <div>
              <label htmlFor="phone" className="block text-sm font-semibold text-[#1A2B3C] mb-3">
                電話番号
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full bg-[#F7F9FB] border border-transparent rounded-xl px-5 py-4 text-[15px] text-[#1A2B3C] focus:outline-none focus:border-[#4A90E2] focus:ring-2 focus:ring-[#4A90E2]/20 transition-all duration-300"
                placeholder="090-1234-5678"
              />
            </div>

            {/* お問い合わせ内容 */}
            <div>
              <label htmlFor="message" className="block text-sm font-semibold text-[#1A2B3C] mb-3">
                お問い合わせ内容 <span className="text-red-500">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                maxLength={500}
                rows={6}
                className="w-full bg-[#F7F9FB] border border-transparent rounded-xl px-5 py-4 text-[15px] text-[#1A2B3C] focus:outline-none focus:border-[#4A90E2] focus:ring-2 focus:ring-[#4A90E2]/20 transition-all duration-300 resize-none"
                placeholder="お問い合わせ内容をご記入ください（500文字以内）"
              ></textarea>
              <p className="text-xs text-[#5A6C7D] mt-2 text-right">
                {formData.message.length} / 500文字
              </p>
            </div>

            {/* プライバシーポリシー同意 */}
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                id="agree"
                name="agree"
                checked={formData.agree}
                onChange={handleChange}
                className="mt-1 w-5 h-5 rounded border-gray-300 text-[#4A90E2] focus:ring-[#4A90E2] cursor-pointer"
              />
              <label htmlFor="agree" className="text-sm text-[#3A4A5A] cursor-pointer">
                <a href="#" className="text-[#4A90E2] hover:underline">
                  プライバシーポリシー
                </a>
                に同意する
              </label>
            </div>

            {/* 送信ボタン */}
            <div className="pt-4">
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full max-w-[400px] mx-auto block h-14 bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] text-white text-lg font-semibold rounded-full hover:shadow-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap ${
                  isSubmitting ? 'cursor-wait' : 'cursor-pointer'
                }`}
              >
                {isSubmitting ? '送信中...' : '入力内容を送信する'}
              </button>
            </div>

            {/* 送信結果メッセージ */}
            {submitStatus === 'success' && (
              <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-xl text-center">
                <p className="text-green-700 font-medium">
                  お問い合わせを受け付けました。ありがとうございます。
                </p>
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-xl text-center">
                <p className="text-red-700 font-medium">
                  送信に失敗しました。もう一度お試しください。
                </p>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
